// data that presumable will coming from backend services

// mapping of featureIds to displayStyles
// used in middleware to augment the responses
export const displayStyleMapping = {
	external: {
		HS_HousingColour: 'colorSelect',
		LE_ReflectorColour_1: 'colorSelect',
		LE_ReflectorColour_2: 'colorSelect',
		LE_DimmingLevel_1: 'reducedSelect',
		LE_DimmingLevel_2: 'reducedSelect',
		HS_HousingPowerConnection: 'reducedSelect',
		HS_LightEmission: 'reducedSelect',
	},
	internal: {
		HS_HousingColour: 'comboSelect',
		LE_ReflectorColour_1: 'colorSelect',
		LE_ReflectorColour_2: 'colorSelect',
		LE_DimmingLevel_1: 'reducedSelect',
		LE_DimmingLevel_2: 'reducedSelect',
		HS_HousingPowerConnection: 'reducedSelect',
		HS_LightEmission: 'reducedSelect'
	}
};

// mapping of featureIds to displayStyles
// used in middleware to augment the responses
export const regionMapping = {
	HS_LightEmissionCAFilter: {
		 //excludeRegions: null,
		includeRegions: 'fra',
		values: {
			ConformeArrete: {
				// excludeRegions: null,
				//includeRegions: 'fra'
			}
		}
	}
};

export const attributeIdReplacements = [
	{
		search: 'LE_LightColour',
		replace: 'LE_ColourTemperature_1'
	}
];
